export const moneyPyramid = [
  { id: 1, amount: "$ 100" },
  { id: 2, amount: "$ 200" },
  { id: 3, amount: "$ 300" },
  { id: 4, amount: "$ 500" },
  { id: 5, amount: "$ 1000" },
  { id: 6, amount: "$ 2000" },
  { id: 7, amount: "$ 4000" },
  { id: 8, amount: "$ 8000" },
  { id: 9, amount: "$ 16000" },
  { id: 10, amount: "$ 32000" },
  { id: 11, amount: "$ 64000" },
  { id: 12, amount: "$ 125000" },
  { id: 13, amount: "$ 250000" },
  { id: 14, amount: "$ 500000" },
  { id: 15, amount: "$ 1000000" },
].reverse();

export const data = [
  {
    id: 1,
    question: "What is hoisting in JavaScript ?",
    answers: [
      {
        text: "JavaScript's behavior of moving declaration to the top",
        correct: true,
      },
      {
        text: "A variable can be declared before it has been used",
        correct: false,
      },
      {
        text: "Web solutions for an individual business or organization",
        correct: false,
      },
      {
        text: "Web host",
        correct: false,
      },
    ],
  },
  {
    id: 2,
    question: "What is the diffrence between Let and Var in JavaScript ?",
    answers: [
      {
        text: "We can redeclare Var but not for the others (Let, Const)",
        correct: true,
      },
      {
        text: "There is no diffrence",
        correct: false,
      },

      {
        text: "Let is a function-scoped",
        correct: false,
      },
      {
        text: "We can redeclare Let but not for the others (Var, Const)",
        correct: false,
      },
    ],
  },
  {
    id: 3,
    question: "What is the purpose of reverse() in JavaScript ?",
    answers: [
      {
        text: "Sorts the elements of an array",
        correct: false,
      },
      {
        text: "Overwrites the original array",
        correct: false,
      },
      {
        text: "Reverse the order of the elements in an array",
        correct: true,
      },
      {
        text: "Method executes the callback function once for each array element",
        correct: false,
      },
    ],
  },
  {
    id: 4,
    question: "What is the deep copy in JavaScript ?",
    answers: [
      {
        text: "Transcript",
        correct: false,
      },
      {
        text: "The value of the new variables is disconnected from the original",
        correct: true,
      },
      {
        text: "Imitation",
        correct: false,
      },
      {
        text: "Method executes copy simple data",
        correct: false,
      },
    ],
  },
  {
    id: 5,
    question: "What is the useMemo hook in ReactJS ?",
    answers: [
      {
        text: "It returns memorized days ",
        correct: false,
      },
      {
        text: "It returns a memorized function",
        correct: false,
      },
      {
        text: "It returns the memorized value",
        correct: true,
      },
      {
        text: "It's the some than the useCallback",
        correct: false,
      },
    ],
  },
  {
    id: 6,
    question: "What is the getDerivedStateFromProps in ReactJS ?",
    answers: [
      {
        text: "it called after any update of the component",
        correct: false,
      },
      {
        text: "This method is used to pass the state to the the props",
        correct: false,
      },
      {
        text: "This method is majorly used to update the props",
        correct: false,
      },
      {
        text: "This method is majorly used to update the state",
        correct: true,
      },
    ],
  },
  {
    id: 7,
    question: "React has ... ?",
    answers: [
      {
        text: "4 lifecycle phases",
        correct: false,
      },
      {
        text: "5 lifecycle phases",
        correct: false,
      },
      {
        text: "3 lifecycle phases",
        correct: true,
      },
      {
        text: "6 lifecycle phases",
        correct: false,
      },
    ],
  },
  {
    id: 8,
    question: "What is RxJs ?",
    answers: [
      {
        text: "Library for reactive programming using observable",
        correct: true,
      },
      {
        text: "Library for reactive programming using promises",
        correct: false,
      },
      {
        text: "Library for routing",
        correct: false,
      },
      {
        text: "Library allows users to use emojis",
        correct: false,
      },
    ],
  },
  {
    id: 9,
    question:
      "When a component is updated, React has ... built-in methods that gets called ?",
    answers: [
      {
        text: "4",
        correct: false,
      },
      {
        text: "5",
        correct: true,
      },
      {
        text: "3",
        correct: false,
      },
      {
        text: "6",
        correct: false,
      },
    ],
  },

  {
    id: 10,
    question: " contextAPI designed for ?",
    answers: [
      {
        text: "Dynamic data",
        correct: false,
      },
      {
        text: "Both static and dynamic data",
        correct: false,
      },
      {
        text: "There is no correct answer",
        correct: false,
      },
      {
        text: "Static data",
        correct: true,
      },
    ],
  },
  {
    id: 11,
    question: "  What is the purpose of Node.js ?",
    answers: [
      {
        text: "Real-time web applications",
        correct: true,
      },
      {
        text: "Allow developers to easily create fast user interfaces",
        correct: false,
      },
      {
        text: "Manage the database",
        correct: false,
      },
      {
        text: "Manage document-oriented information, store or retrieve information",
        correct: false,
      },
    ],
  },
  {
    id: 12,
    question:
      "  A web application is distinguished in 4 layers, among these layers there is a layer called business layer , it contains : ?",
    answers: [
      {
        text: "Aplication system / file System",
        correct: true,
      },
      {
        text: "Web server",
        correct: false,
      },
      {
        text: "Mobile browser / Web browser / Application",
        correct: false,
      },

      {
        text: "Database / Externel System",
        correct: false,
      },
    ],
  },
  {
    id: 13,
    question: " How many types of API functions are available in Node.js?",
    answers: [
      {
        text: "Only one",
        correct: false,
      },
      {
        text: "2",
        correct: true,
      },
      {
        text: "3",
        correct: false,
      },
      {
        text: "There is no correct answer",
        correct: false,
      },
    ],
  },
  {
    id: 14,
    question: " The running engine for Node.js is ...",
    answers: [
      {
        text: "V8 (Gecko)",
        correct: false,
      },
      {
        text: "V8 (Google Chrome)",
        correct: true,
      },
      {
        text: "V6 (Google Chrome)",
        correct: false,
      },
      {
        text: "V8 (Opera)",
        correct: false,
      },
    ],
  },
  {
    id: 15,
    question: "what is the callback hell in Node.js",
    answers: [
      {
        text: "is a phenomenon when we cannot recieve data from the dataBase",
        correct: false,
      },
      {
        text: "is a phenomenon for a JavaScript developer when he tries to execute multiple asynchronous operations one after the other",
        correct: true,
      },
      {
        text: "it is a normal phenomenon because Node is a multiple-threaded application with event looping.",
        correct: false,
      },
      {
        text: "There is no correct answer",
        correct: false,
      },
    ],
  },

  // {
  //   id: 1,
  //   question: "Rolex is a company that specializes in what type of product?",
  //   answers: [
  //     {
  //       text: "Phone",
  //       correct: false,
  //     },
  //     {
  //       text: "Watches",
  //       correct: true,
  //     },
  //     {
  //       text: "Food",
  //       correct: false,
  //     },
  //     {
  //       text: "Cosmetic",
  //       correct: false,
  //     },
  //   ],
  // },
  // {
  //   id: 2,
  //   question: "When did the website `Facebook` launch?",
  //   answers: [
  //     {
  //       text: "2004",
  //       correct: true,
  //     },
  //     {
  //       text: "2005",
  //       correct: false,
  //     },
  //     {
  //       text: "2006",
  //       correct: false,
  //     },
  //     {
  //       text: "2007",
  //       correct: false,
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   question: "Who played the character of harry potter in movie?",
  //   answers: [
  //     {
  //       text: "Johnny Deep",
  //       correct: false,
  //     },
  //     {
  //       text: "Leonardo Di Caprio",
  //       correct: false,
  //     },
  //     {
  //       text: "Denzel Washington",
  //       correct: false,
  //     },
  //     {
  //       text: "Daniel Red Cliff",
  //       correct: true,
  //     },
  //   ],
  // },
];
